import {PrecogTypesEnum} from '../../../../src/models/api/precogModel';
import {
  directPrecogsDeletedEventName,
  directPrecogsUpdatedEventName,
  getConversationRoomName,
} from '../../../push/pushHelpers';

export function emitDirectPrecogUpdated(
  conversationId: number,
  userId: number,
  precogsType: PrecogTypesEnum,
  emitDirectEvent: (roomName: string, eventName: string, data: any) => void,
) {
  emitDirectEvent(getConversationRoomName(conversationId), directPrecogsUpdatedEventName, {
    conversation_id: conversationId,
    precog: {
      conversation_id: conversationId,
      teammate_id: userId,
      type: precogsType,
      updated_at: Date.now(),
    },
  });
}

export function emitDirectPrecogDeleted(
  conversationId: number,
  userId: number,
  precogsType: PrecogTypesEnum,
  emitDirectEvent: (roomName: string, eventName: string, data: any) => void,
) {
  emitDirectEvent(getConversationRoomName(conversationId), directPrecogsDeletedEventName, {
    conversation_id: conversationId,
    teammate_id: userId,
    type: precogsType,
  });
}
